import React from 'react';
import { AppButton, Box, Inscription, Preloader, WarningIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  isLoading?: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

const UnlockConfirmModal: React.FC<Props> = ({ isLoading, onSetVisible, onSubmit }) => (
  <ModalWrapper testId="unlock-credentials" visible onSetVisible={onSetVisible}>
    <Box align="center">
      <WarningIcon size="48px" />

      <Inscription data-testId="unlock-credentials-modal_title" margin={{ top: 'spacing12' }} size="2xl" weight={700}>
        Unlock Access?
      </Inscription>

      <Inscription data-testId="unlock-credentials-modal_subtitle" textAlign="center" margin={{ top: 'spacing12' }}>
        This employee will grant access to the system.
      </Inscription>

      <Box margin={{ top: 'spacing24' }} direction="row" width="100%" justify="center">
        <Box width={{ max: '200px', width: '100%' }}>
          <AppButton
            testId="unlock-credentials-modal_close"
            onClick={() => onSetVisible(false)}
            width="100%"
            buttonType="secondary"
          >
            Close
          </AppButton>
        </Box>
        <Box width={{ max: '200px', width: '100%' }} margin={{ left: 'spacing12' }}>
          <AppButton
            testId="unlock-credentials-modal_unlock"
            onClick={onSubmit}
            width="100%"
          >
            {isLoading ? <Preloader /> : 'Yes, Unlock'}
          </AppButton>
        </Box>
      </Box>
    </Box>
  </ModalWrapper>
);

export default UnlockConfirmModal;
